import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import { Box, Text } from 'grommet';
import AccessibleSelect from '../Components/AccessibleSelect';
import ReactTable from "react-table";
import data from '../Data.json';
import { STATOPRATICHE } from '../Constants.js';
import Pagination from './../Components/Pagination';
import MenuDispute from '../Components/MenuDispute.js';


class StatoPratiche extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            selected: '',
            selectedCode: '',
            statepratiche: this.props.location.statepratiche
        }
        this.openPratiche = this.openPratiche.bind(this);
        this.setSelection = this.setSelection.bind(this);
        this.setSelectionCodeEs = this.setSelectionCodeEs.bind(this);

    }

    openPratiche() {
        this.props.history.push({
            pathname: ''
        })
    }

    setSelection(event) {
        this.setState({
            selected: event.value
        })
    }

    setSelectionCodeEs(event) {
        this.setState({
            selectedCode: event.value
        })
    }

    render() {
        const options = [
            "Data scadenza",
            "PV",
            "Data operazione",
            "Importo",
            "Numero carta"
        ]

        const optionsCodEs = [
            "",
            "6848468464"
        ]

        const columns = [
            {
                Header: 'Scadenza',
                accessor: 'codes',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Codice punto vendita',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Insegna/Località',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Data operazione',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Numero carta',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Importo transazione',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'Importo contestato',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'N. pratica',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            }
        ]

        return (
            <Box>
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }} >
                    <Box className='contentbox' >
                        <Box>
                            <MenuDispute></MenuDispute>
                        </Box>
                        <Box align='start' style={{ margin: '20px 16px' }}>
                            <Text className='titlehome'>{STATOPRATICHE.titleStatoPratiche} {this.state.statepratiche === 0 ? "NUOVE"
                                : this.state.statepratiche === 1 ? "IN SOSPESO"
                                    : this.state.statepratiche === 2 ? "IN SCADENZA"
                                        : this.state.statepratiche === 3 ? "IN VISIONE"
                                            : this.state.statepratiche === 4 ? "ANNULLATE"
                                                : this.state.statepratiche === 5 ? ""
                                                    : ""}</Text>
                            <Text className='preline textParagraph' style={{ marginTop: '10px' }} >{STATOPRATICHE.textStatoPratiche}</Text>
                        </Box>
                        <Box align='start' style={{ margin: '16px' }} id='searchpv'>
                            <Box id='test' style={{ width: '100%', marginBottom: '30px' }} direction='row' className='rowColumn' >
                                <Box style={{ marginRight: '30px' }} >
                                    <Text className='label' id='order-by-label' htmlFor='order-by' aria-hidden="false">ORDINA PER:</Text>
                                    <AccessibleSelect 
                                        id='order-by' 
                                        className='select' 
                                        placeholder='' 
                                        options={options} 
                                        value={this.state.selected} 
                                        onChange={this.setSelection}
                                        aria-labelledby='order-by-label'
                                        a11yTitle='Ordina per'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di ordinamento disponibili',
                                            role: 'listbox',
                                            'aria-multiselectable': 'false'
                                        }}
                                    />
                                </Box>
                                <Box >
                                    <Text className='label' id='search-code-label' htmlFor='search-code' aria-hidden="false">RICERCA PER CODICE ESERCENTE:</Text>
                                    <AccessibleSelect 
                                        id='search-code' 
                                        className='select' 
                                        placeholder='' 
                                        options={optionsCodEs} 
                                        value={this.state.selectedCode} 
                                        onChange={this.setSelection}
                                        aria-labelledby='search-code-label'
                                        a11yTitle='Ricerca per codice esercente'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di codici esercente disponibili',
                                            role: 'listbox',
                                            'aria-multiselectable': 'false'
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Box style={{ width: '100%' }}>
                                <ReactTable
                                    PaginationComponent={Pagination}
                                    data={data.table}
                                    columns={columns}
                                    sortable={true}
                                    multiSort={true}
                                    resizable={true}
                                    showPagination={true}
                                    loading={false}
                                    defaultPageSize={10}
                                    style={{ paddingBottom: '20px' }} />
                            </Box>
                        </Box>
                    </Box>

                </Box>

            </Box>


        )
    }
}

export default withRouter(StatoPratiche)